import React from "react";
import styled from "styled-components";

const ParentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  /* margin-bottom: 24px; */
  width: 100%;
`;

const Label = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: ${({ theme }) => theme.black};
  margin-left: 4px;

  @media (max-width: 768px) {
    font-size: 17px;
  }

  @media (max-width: 480px) {
    font-size: 16px;
  }
`;

const Container = styled.div`
  position: relative;
  width: 100%;
  height: 56px;
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid ${({ theme }) => theme.darkGray8};
  border-radius: 12px;
  padding: 0 16px;
  backdrop-filter: blur(6px);
  transition: border 0.3s ease;

  &:focus-within {
    border-color: ${({ theme }) => theme.secondary};
  }

  @media (max-width: 768px) {
    height: 52px;
  }

  @media (max-width: 480px) {
    height: 48px;
  }
`;

const Input = styled.input`
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-size: 16px;
  font-weight: 500;
  color: ${({ theme }) => theme.black};

  &::placeholder {
    color: ${({ theme }) => theme.gray25};
    font-weight: 400;
  }

  @media (max-width: 768px) {
    font-size: 15px;
  }

  @media (max-width: 480px) {
    font-size: 14px;
  }
`;

const Icon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 12px;
  color: ${({ theme }) => theme.black};
  font-size: 20px;

  svg {
    width: 20px;
    height: 20px;
  }

  @media (max-width: 480px) {
    font-size: 18px;

    svg {
      width: 18px;
      height: 18px;
    }
  }
`;

const TextInputWithIcon = ({
  placeholder,
  type,
  icon,
  value,
  name,
  handleChange,
  handleKeyUp,
  max,
  min,
  maxLength,
  minLength,
  readonly,
  onFocus,
  label,
}) => {
  return (
    <ParentContainer>
      {label && <Label>{label}</Label>}
      <Container>
        <Input
          placeholder={placeholder}
          type={type}
          name={name}
          value={value}
          onChange={handleChange}
          onKeyUp={handleKeyUp}
          max={max}
          min={min}
          maxLength={maxLength}
          minLength={minLength}
          readOnly={readonly}
          onFocus={onFocus}
        />
        {icon && <Icon data-testid="icon">{icon}</Icon>}
      </Container>
    </ParentContainer>
  );
};

export default TextInputWithIcon;
